import {fetchConfig} from "@/store/api/api";
import {debounce} from "lodash";

export default {
    namespaced: true,
    state: {
        /**
         * ID партнера
         * {Number} - id
         */
        partnerId: null,
        /**
         * Локаль
         * {String} - вида ru-BY, ru-RU, en-US, en-UK
         */
        locale: 'ru-BY',
        /**
         * Код валюты
         * {String} - код вида BYN, RUB, EUR, USD
         */
        currency: 'BYN',
        /**
         * Маркировка для обычной цены
         * {String | 'Полный'}
         */
        priceNormTitle: 'Полный',
        /**
         * Маркировка для льготной цены
         * {String | 'Льготный'}
         */
        priceDiscTitle: 'Льготный',
        /**
         * Обращение к персоналу ('Мастер' | 'Доктор' | 'Лектор' | 'Тренер' и т.п.)
         * {String | 'Персонал'}
         */
        personAppeal: 'Персонал',
        /**
         * Варианты по умолчанию для опций
         * {Number} - id
         */
        optionsPreset: {
            date: {
                start: null,
                end: null,
            },
            addressId: null,
            itemId: null,
            variationId: null,
            personId: null,
        },
        /**
         * Видимость определенных шагов (дата/адрес/услуга/...)
         * {Boolean} - флаг
         * TODO: Пока не реализовано
         */
        optionsVisibility: {
            date: true,
            address: true,
            item: true,
            variation: true,
            person: true,
        },
        /**
         * Показывать ли цены на событиях
         * (полезно скрывать, если для всех событий одинаковая стоимость)
         * {Boolean} - флаг
         * TODO: Пока не реализовано
         */
        isShowEventPrice: true,
        /**
         * Показывать ли кол-во мест на событиях
         * (полезно скрывать, если для всех событий всегда только одно место)
         * {Boolean} - флаг
         * TODO: Пока не реализовано
         */
        isShowEventPlaces: true,
        /**
         * Возможность выбора нескольких мест (на этапе рассчета цены)
         * {Boolean} - флаг
         * TODO: Пока не реализовано
         */
        isAmountEditable: true,
        /**
         * Возможность выбора и оформления нескольких событий за раз
         * {Boolean} - флаг
         * TODO: Пока не реализовано
         */
        isMultiEvents: false,
        /**
         * Варианты оплаты
         * {Object} - флаг
         * TODO: Пока не реализовано
         */
        paymentOptions: {}
    },
    getters: {
        getLocale(state) {
            return state.locale;
        },
        getCurrency(state) {
            return state.currency;
        },
        getPriceNormTitle(state) {
            return state.priceNormTitle;
        },
        getPriceDiscTitle(state) {
            return state.priceDiscTitle;
        },
        getPersonAppeal(state) {
            return state.personAppeal;
        }
    },
    mutations: {
        setState(state, payload) {
            state.partnerId = payload.partner_id;
            state.locale = payload.locale;
            state.currency = payload.currency;
            state.priceNormTitle = payload.price_norm_title;
            state.priceDiscTitle = payload.price_disc_title;
            state.personAppeal = payload.person_appeal;
            state.optionsPreset = payload.options_preset;
            state.optionsVisibility = payload.options_visibility;
            state.isShowEventPrice = payload.is_show_event_price;
            state.isAmountEditable = payload.is_amout_editable;
            state.isMultiEvents = payload.is_multi_events;
        },
    },
    actions: {
        async fetchConfig({commit}, options) {
            const config = await fetchConfig(options)
            commit('setState', config);
        },
        applyOptionsPreset({state, commit}) {
            const {
                date: date,
                address: addressId,
                item: itemId,
                variation: variationId,
                person: personId,
            } = state.optionsPreset;

            commit('date/setDateRangeAsTimestamps', {
                startDateTimestamp: date.start,
                endDateTimestamp: date.end
            }, {root: true});
            commit('address/setCurrentAddress', addressId, {root: true});
            commit('item/setCurrentItem', itemId, {root: true});
            commit('variation/setCurrentVariation', variationId, {root: true});
            commit('person/setCurrentPerson', personId, {root: true});

            console.log('[config] Значения по умолчанию выставлены');
        },
        saveStateToLocalStorage: debounce(({state, rootState}) => {
            // Для каждого отдельного партнера создается свой объект состояния в LocalStorage
            // В поле 'updated' записывается дата изменения объекта
            const {partnerId} = state;
            const data = JSON.stringify({
                updated: new Date(),
                date: {...rootState['date']},
                address: {id: rootState['address'].id},
                item: {id: rootState['item'].id},
                variation: {id: rootState['variation'].id},
                person: {id: rootState['person'].id},
                // event: {events: rootState['event'].events},
                // places: {...rootState['places']},
                // payment: {value: rootState['payment'].value},
            });
            localStorage.setItem(`config_${partnerId}`, data);
            console.log('[config] Состояние сохранено в LocalStorage');
        }, 300),
        removeStateFromLocalStorage({state}) {
            const {partnerId} = state;
            localStorage.removeItem(`config_${partnerId}`);
            console.log('[config] Устаревшее состояние удалено из LocalStorage');
        },
        async loadStateFromLocalStorage({state, dispatch}) {
            const {partnerId} = state;
            const data = JSON.parse(localStorage.getItem(`config_${partnerId}`));

            // Проверяется наличие данных
            if (!data) {
                console.log('[config] Состояний для загрузки из LocalStorage не найдено');
                return false;
            }

            // Проверяется актуальность данных (не старше 48 часов)
            const subtract = +new Date() - +new Date(data.updated);
            if (subtract > 172800000) {
                console.log('[config] Состояние для загрузки из LocalStorage устарело');
                dispatch('removeStateFromLocalStorage');
                return false;
            }

            await dispatch('loadDateFromState', data.date);
            await dispatch('loadAddressFromState', data.address);
            await dispatch('loadItemFromState', data.item);
            await dispatch('loadPersonFromState', data.person);
            await dispatch('loadVariationFromState', data.variation);
            // Поле "Дата и время" и зависимые от него поля восстановить из LocalStorage нельзя
            // т.к. они известны исключительно исходя из выбранного события
            // События же подгружаются отдельным запросом, и актуальность события проверить здесь не получится

            console.log('[config] Предыдущее состояние загружено из LocalStorage');
        },
        loadDateFromState({dispatch}, {startDate, endDate}) {
            if (startDate && endDate) {
                startDate = +new Date(startDate) < +new Date() ? new Date() : startDate;
                endDate = +new Date(endDate) < +new Date() ? new Date() : endDate;
                dispatch('date/setDate', {startDate, endDate}, {root: true});
                console.log('[config] Восстановлено значение поля "Когда"');
                return true;
            }
        },
        loadAddressFromState({dispatch, rootGetters}, {id}) {
            if (rootGetters['address/isAddressExist'](id)) {
                dispatch('address/setCurrentAddress', id, {root: true});
                console.log('[config] Восстановлено значение поля "Адрес"');
                return true;
            }
        },
        loadItemFromState({dispatch, rootGetters}, {id}) {
            if (rootGetters['item/isItemExist'](id)) {
                dispatch('item/setCurrentItem', id, {root: true});
                console.log('[config] Восстановлено значение поля "Услуга"');
                return true;
            }
        },
        loadVariationFromState({dispatch, rootGetters}, {id}) {
            if (rootGetters['variation/isVariationExist'](id)) {
                dispatch('variation/setCurrentVariation', id, {root: true});
                console.log('[config] Восстановлено значение поля "Вариант услуги"');
                return true;
            }
        },
        loadPersonFromState({state, dispatch, rootGetters}, {id}) {
            if (rootGetters['person/isPersonExist'](id)) {
                dispatch('person/setCurrentPerson', id, {root: true});
                console.log(`[config] Восстановлено значение поля "${state.personAppeal}"`);
                return true;
            }
        },
    }
}
